import Vue from "vue";
import Router from "vue-router";

import auth from "@/auth";
import defaultLayout from "@/layouts/side-nav-inner-toolbar";
import simpleLayout from "@/layouts/single-card";
import { SysConfig, PageConfig, CommonCode } from "@/env/SysConfig.js";

Vue.use(Router);

const viewPrefixPath = "./views";

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const router = new Router({
  mode: "history" /* URL에서 #을 제거하려면 mode 속성을 history로 주면됨  */,
  routes: [
    {
      path: "/",
      redirect: "/Home", //"/Home",  // 추후 TODO 원복해야함. 2021-11-04
    },
    {
      path: "*",
      redirect: "/Home", //"/Home",  // 추후 TODO 원복해야함. 2021-11-04
    },
    {
      path: "/Home",
      name: "Home",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: "Home" */
            `${viewPrefixPath}/Home.vue`
          ),
      },
    },
    {
      path: "/HomeSTOM",
      name: "HomeSTOM",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: "HomeSTOM" */
            `${viewPrefixPath}/HomeSTOM.vue`
          ),
      },
    },
    {
      path: "/Buyer/Requisition/",
      name: "Requisition",
      id: 1,
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Requisition' */ `${viewPrefixPath}/Buyer/Requisition/Main.vue`
          ),
      } /* 구매요청서 */,
    },
    {
      path: "/Buyer/Test/",
      name: "Test",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Test' */ `${viewPrefixPath}/Buyer/Test/Main.vue`
          ),
      } /* 구매요청서 */,
    },

    {
      path: "/Buyer/Rfq/",
      name: "Rfq",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Rfq' */ `${viewPrefixPath}/Buyer/Rfq/Main.vue`
          ),
      } /* 견적의뢰서 */,
    },

    {
      path: "/Buyer/QuotationBox/",
      name: "QuotationBox",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'QuotationBox' */ `${viewPrefixPath}/Buyer/QuotationBox/Main.vue`
          ),
      } /* 견적의뢰서 */,
    },
    {
      path: "/Buyer/Order/",
      name: "Order",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Order' */ `${viewPrefixPath}/Buyer/Order/Main.vue`
          ),
      } /* 발주서 */,
    },
    {
      path: "/Buyer/Purchase/",
      name: "Purchase",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Purchase' */ `${viewPrefixPath}/Buyer/Purchase/Main.vue`
          ),
      } /* 매입 */,
    },
    {
      path: "/Buyer/PurchaseTax/",
      name: "PurchaseTax",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'PurchaseTax' */ `${viewPrefixPath}/Buyer/PurchaseTax/Main.vue`
          ),
      } /* 전자계산서 조회 */,
    },

    {
      path: "/Supplier/RfqBox/",
      name: "RfqBox",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'RfqBox' */ `${viewPrefixPath}/Supplier/RfqBox/Main.vue`
          ),
      } /* 견적의뢰서 확인 */,
    },
    {
      path: "/Supplier/Quotation/",
      name: "Quotation",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Quotation' */ `${viewPrefixPath}/Supplier/Quotation/Main.vue`
          ),
      } /* 견적서 */,
    },
    {
      path: "/Supplier/Quotation4STOM/",
      name: "Quotation4STOM",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Quotation4STOM' */ `${viewPrefixPath}/Supplier/Quotation4STOM/Main.vue`
          ),
      } /* 견적서 */,
    },
    {
      path: "/Supplier/OrderAck/",
      name: "OrderAck",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'OrderAck' */ `${viewPrefixPath}/Supplier/OrderAck/Main.vue`
          ),
      } /* 발주서 확인 */,
    },
    {
      path: "/Supplier/Sales/",
      name: "Sales",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Sales' */ `${viewPrefixPath}/Supplier/Sales/Main.vue`
          ),
      } /* 매출 */,
    },
    {
      path: "/Supplier/SalesTax/",
      name: "SalesTax",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'SalesTax' */ `${viewPrefixPath}/Supplier/SalesTax/Main.vue`
          ),
      } /* 전자계산서 발행 */,
    },

    {
      path: "/Statistics/QuotationPerformance/",
      name: "QuotationPerformance",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'QuotationPerformance' */ `${viewPrefixPath}/Statistics/QuotationPerformance/Main.vue`
          ),
      } /* 견적요청 대비 견적실적 */,
    },
    {
      path: "/Statistics/OrderAmount/",
      name: "OrderAmount",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'OrderAmount' */ `${viewPrefixPath}/Statistics/OrderAmount/Main.vue`
          ),
      } /* 발주금액집계 */,
    },
    {
      path: "/Statistics/OrderAnalysis/",
      name: "OrderAnalysis",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'OrderAnalysis' */ `${viewPrefixPath}/Statistics/OrderAnalysis/Main.vue`
          ),
      } /* 발주 단가분석 보고서 */,
    },
    {
      path: "/Statistics/SaleStatus/",
      name: "SaleStatus",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'SaleStatus' */ `${viewPrefixPath}/Statistics/SaleStatus/Main.vue`
          ),
      } /* 매출현황 */,
    },
    {
      path: "/Statistics/SaleTotal/",
      name: "SaleTotal",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'SaleTotal' */ `${viewPrefixPath}/Statistics/SaleTotal/Main.vue`
          ),
      } /* 매출집계 */,
    },

    {
      path: "/Code/Client/",
      name: "Client",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Client' */ `${viewPrefixPath}/Code/Client/Main.vue`
          ),
      } /* 거래처 */,
    },
    {
      path: "/Code/CommonCode/",
      name: "CommonCode",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'CommonCode' */ `${viewPrefixPath}/Code/CommonCode/Main.vue`
          ),
      } /* 공통코드 */,
    },
    {
      path: "/Code/ProductCode/",
      name: "ProductCode",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'ProductCode' */ `${viewPrefixPath}/Code/ProductCode/Main.vue`
          ),
      } /* 품목코드 */,
    },
    {
      path: "/Code/ShipCode/",
      name: "ShipCode",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'ShipCode' */ `${viewPrefixPath}/Code/ShipCode/Main.vue`
          ),
      } /* 선박코드 */,
    },

    {
      path: "/Sys/DictionaryMgnt/",
      name: "DictionaryMgnt",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'DictionaryMgnt' */ `${viewPrefixPath}/Sys/DictionaryMgnt/Main.vue`
          ),
      } /* 용어사전 */,
    },
    {
      path: "/Sys/MenuMgnt/",
      name: "MenuMgnt",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'MenuMgnt' */ `${viewPrefixPath}/Sys/MenuMgnt/Main.vue`
          ),
      } /* 메뉴관리 */,
    },
    {
      path: "/Sys/RoleMgnt/",
      name: "RoleMgnt",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: () =>
          import(
            /* webpackChunkName: 'RoleMgnt' */ `${viewPrefixPath}/Sys/RoleMgnt/Main.vue`
          ),
      } /* 권한관리 */,
    },

    {
      path: "/login",
      name: "login",
      meta: { requiresAuth: true },
      components: {
        layout: simpleLayout,
        content: () =>
          import(
            /* webpackChunkName: 'Login' */ `${viewPrefixPath}/Sys/Login.vue`
          ),
      } /* 권한관리 */,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const memberEtcType =
    SysConfig?.userInfo?.memberEtcType || localStorage.getItem("memberEtcType");
    if (to.name === "login-form" && auth.loggedIn()) {
      if (memberEtcType == "STOM") {
        next({ name: "Quotation4STOM" });  // Login.vue 내 로직 동기화할것!
      } else {
        next({ name: "Home" });
      }
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
